import gql from "graphql-tag";
import {
  FRAGMENT_RECORDING,
  FRAGMENT_EXPORT,
  FRAGMENT_FILE,
  FRAGMENT_PAGINATION_META
} from "./fragments";

export const QUERY_RECORDINGS = gql`
  query recordings($folderId: Int, $limit: Int, $search: String, $page: Int) {
    recordings(
      folderId: $folderId
      limit: $limit
      page: $page
      search: $search
    ) {
      items {
        ...recording
      }
      meta {
        ...meta
      }
    }
  }

  ${FRAGMENT_RECORDING}

  ${FRAGMENT_PAGINATION_META}
`;

export const QUERY_FILES = gql`
  query files($amount: Int!, $offset: Int!, $folderId: Int) {
    files: legacyFiles(
      first: $amount
      offset: $offset
      condition: { folderId: $folderId }
      orderBy: [ID_DESC]
      filter: { sourceId: { isNull: true } }
    ) {
      file: nodes {
        ...file
        exports: legacyFilesBySourceIdList {
          ...file
        }
      }
    }
  }

  ${FRAGMENT_FILE}
`;

export const QUERY_FILE = gql`
  query file($fileUuid: String!) {
    file: legacyFileByFileUuid(fileUuid: $fileUuid) {
      ...file
    }
  }

  ${FRAGMENT_FILE}
`;

export const QUERY_RECORDING = gql`
  query recording($id: String!, $limit: Int, $page: Int) {
    recording(id: $id) {
      id
      scenario
      quality
      exports(limit: $limit, page: $page) {
        meta {
          totalItems
          itemCount
          itemsPerPage
          totalPages
          currentPage
        }
        items {
          ...Export
        }
      }
    }
  }
  ${FRAGMENT_EXPORT}
`;

export const QUERY_TAGS = gql`
  query Tags {
    tags {
      label
    }
  }
`;

export const SUBSCRIPTION_ANY_FILE_FINISHED_PROCESSING = gql`
  subscription filesFinishedProcessing {
    filesFinishedProcessing {
      file {
        ...file
      }
    }
  }

  ${FRAGMENT_FILE}
`;
export const SUBSCRIPTION_FILE_FINISHED_PROCESSING = gql`
  subscription fileFinishedProcessing($fileUuid: String!) {
    fileFinishedProcessing(fileUuid: $fileUuid) {
      file {
        ...file
      }
    }
  }

  ${FRAGMENT_FILE}
`;

export const MUTATION_UPDATE_FILE = gql`
  mutation updateFile($fileUuid: String!, $input: UpdateRecordingDto!) {
    updateRecording(id: $fileUuid, input: $input) {
      ...recording
    }
  }

  ${FRAGMENT_RECORDING}
`;

export const MUTATION_DELETE_FILE = gql`
  mutation deleteFile($fileUuid: String!) {
    deleteRecording(id: $fileUuid)
  }
`;

export const MUTATION_PROCESS_EXPORT_FILE = gql`
  mutation processExportFile($fileUuid: String!, $input: JSON!) {
    processExportFile(input: { fileUuid: $fileUuid, input: $input }) {
      clientMutationId
    }
  }
`;

export const MUTATION_PROCESS_EXPORT_FILE_TO_FOLDER = gql`
  mutation processExportFileToFolder(
    $fileUuid: String!
    $input: JSON!
    $folderId: Int!
  ) {
    processExportFileToFolder(
      input: { fileUuid: $fileUuid, input: $input, folderId: $folderId }
    ) {
      clientMutationId
    }
  }
`;
